import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import QuizGeneratorPage from '../../features/quiz-generation/components/QuizGeneratorPage';

const QuizGenerationPageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <QuizGeneratorPage />
    </ProtectedRoute>
  );
};

export default QuizGenerationPageRoute;

